var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main d-flex" }, [
    _c("div", { staticClass: "navigation-ct" }, [
      _vm.showNavLinkSection
        ? _c(
            "div",
            { staticClass: "nav-item-list" },
            [_vm._t("main-panel-links")],
            2
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "width-100" }, [_vm._t("main-panel-content")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }